import React, { SVGProps } from 'react';

export function JSIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="10" fill="black" />
      <path
        fill="#f0dc4e"
        fillRule="evenodd"
        d="M5 0a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5H5Zm9.077 12.273h-1.824v6.085c0 .278-.041.513-.124.703a.932.932 0 0 1-.362.435 1.074 1.074 0 0 1-.575.145c-.216 0-.404-.043-.563-.128a.96.96 0 0 1-.37-.375 1.312 1.312 0 0 1-.141-.593H8.28c-.003.58.121 1.061.371 1.445.25.38.588.665 1.014.852.43.185.906.277 1.432.277.59 0 1.11-.112 1.555-.336a2.507 2.507 0 0 0 1.044-.96c.253-.414.38-.902.38-1.465v-6.085Zm5.82 1.709c.26.19.406.457.44.8h1.768a2.446 2.446 0 0 0-.418-1.371c-.27-.395-.647-.704-1.133-.925-.483-.222-1.048-.333-1.696-.333-.636 0-1.205.111-1.705.333-.5.221-.893.53-1.18.925-.284.394-.425.856-.422 1.385-.003.644.209 1.157.635 1.538.426.38 1.007.66 1.743.84l.95.238c.318.077.587.162.806.256.221.093.389.207.503.34a.725.725 0 0 1 .174.495c0 .21-.064.396-.191.558a1.249 1.249 0 0 1-.542.38 2.21 2.21 0 0 1-.814.136c-.318 0-.603-.049-.856-.145-.25-.1-.45-.246-.601-.44a1.34 1.34 0 0 1-.252-.732h-1.785c.014.628.166 1.155.456 1.58.293.424.699.744 1.219.96.523.216 1.136.324 1.84.324.71 0 1.317-.107 1.82-.32.506-.216.892-.518 1.16-.908.27-.392.406-.855.408-1.389a2.314 2.314 0 0 0-.2-.967 2.178 2.178 0 0 0-.541-.733 3.184 3.184 0 0 0-.827-.524 5.524 5.524 0 0 0-1.048-.341l-.784-.188a4.62 4.62 0 0 1-.537-.153 2.297 2.297 0 0 1-.443-.218 1.023 1.023 0 0 1-.303-.302.718.718 0 0 1-.098-.41c0-.187.054-.354.162-.502.11-.148.27-.263.477-.345.208-.085.462-.128.763-.128.443 0 .794.095 1.053.286Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default JSIcon;
